
import CarouselImages from '@/components/pages/product/CarouselImages.vue';
import ProductInformations from '@/components/pages/product/ProductInformations.vue';
import ProductLoading from '@/components/pages/product/ProductLoading.vue';
import ProductRelationship from '@/components/pages/product/ProductRelationship.vue';
import ProductSizes from '@/components/pages/product/ProductSizes.vue';
import { Button, Collapse, CollapseItem } from 'element-ui';
import ProductNotAvailable from '@/components/products/ProductNotAvailable.vue';
import { Edit2Icon, MapPinIcon } from 'vue-feather-icons';
import cartMixin from '@/mixins/cartMixin.js';
import PageNotFound from '@/layouts/components/PageNotFound.vue';
import { Alert } from 'element-ui';
import { ProductHelpers } from '@/helpers/ProductHelpers.js';

// const fetchProduct = async (store, { permalink }) => {
//   return await store.dispatch("product/fetchProduct", {
//     permalink,
//   });
// };
// const pageNotFound = (context) => {
//   context.error({
//     statusCode: 404,
//     message: context.app.i18n.t("the product you requested no longer exists"),
//   });
// };

export default {
  layout: 'MainLayout',
  name: 'ProductPage',
  auth: false,
  mixins: [cartMixin],
  head() {
    try {
      if (this.seo) {
        return {
          title: this.seo?.MetaTitle,
          meta: [
            {
              hid: 'description',
              name: 'description',
              content: this.seo.MetaDescription,
            },
            {
              hid: 'og:image',
              property: 'og:image',
              content: this.productImages.lenght
                ? this.productImages[0].Src
                : '',
            },
          ],
        };
      }
    } catch (error) {}
    return {};
  },

  data() {
    return {
      taillesIsOpen: false,
      isSelectedSize: true,
      colorSelected: '',
      sizeSelected: null,
      isSelectedSize: true,
      isAvailbale: true,
      loading: true,
      notFound: false,
      hideAddToCartMobile: false,
      idProductAttributeSelected: null,
      entranceTime: null,
    };
  },
  computed: {
    product() {
      return this.$store.state.product.currentProduct;
    },
    productTitle() {
      if (this.product != null) {
        try {
          return this.product.Description.Title;
        } catch (error) {}
      }
      return '';
    },
    productDescription() {
      if (this.product != null) {
        try {
          return this.product.Description.Description;
        } catch (error) {}
      }
      return '';
    },
    productDescriptionShort() {
      if (this.product != null) {
        try {
          return this.product.Description.DescriptionShort;
        } catch (error) {}
      }
      return '';
    },
    productImages() {
      try {
        if (this.product.Media) {
          return this.product.Media.Images.product_large;
        }
      } catch (error) {}

      return [];
    },
    productImagesXLarge() {
      try {
        if (this.product.Media) {
          return this.product.Media.Images.product_xlarge;
        }
      } catch (error) {}

      return [];
    },
    productVideos() {
      try {
        if (this.product.Media) {
          return this.product.Media.Videos;
        }
      } catch (error) {}

      return [];
    },

    promotion() {
      let price = this.product.Price;
      return price.PromotionalPrice;
    },
    promotionPercentage() {
      const price = Number(this.productPrice);
      const pricePromotion = Number(this.productPricePromotion);

      return ((1 - pricePromotion / price) * 100).toFixed(0);
    },
    productPricePromotion() {
      return this.promotion.PriceTaxIncl;
    },
    productPrice() {
      if (this.promotion) {
        return this.productPricePromotion;
      }
      return this.product.Price.RegularPrice.PriceTaxIncl;
    },

    breadcrumbLinks() {
      const links = [
        {
          link: '/',
          text: this.$t('Home'),
        },
      ];
      if (this.mainCatgoryTitle) {
        links.push({
          link: this.localePath(`/${this.urlCategory}`),
          text: this.mainCatgoryTitle,
        });
      }

      links.push({
        text: this.productTitle,
      });
      return links;
    },

    variants() {
      return this.product.Variant;
    },

    mainCatgoryTitle() {
      try {
        const seo = this.product?.Category?.Main?.SEO;
        if (seo) {
          const mainCategory = seo.find((item) => {
            return this.$i18n.locale === item.LanguageIsoCode.toLowerCase();
          });
          if (!mainCategory) {
            return null;
          }
          if (mainCategory.MetaTitle) {
            return mainCategory.MetaTitle;
          }
        }
      } catch (error) {}
      return null;
    },
    urlCategory() {
      try {
        const seo = this.product?.Category?.Main?.SEO;

        if (seo) {
          const mainCategory = seo.find((item) => {
            return this.$i18n.locale === item.LanguageIsoCode.toLowerCase();
          });
          if (!mainCategory) {
            return 'product';
          }
          if (mainCategory?.URL) {
            return mainCategory?.URL;
          }
        }
      } catch (error) {}
      return 'product';
    },
    Delivery() {
      if (this.product.Delivery) {
        return this.product.Delivery;
      }
      return null;
    },
    dateOfDeilvery() {
      if (this.Delivery === null) {
        return false;
      }
      if (this.Delivery.Time) {
        const formatDate = new FormatDate();
        if (this.Delivery.Time.From) {
          const dateMin = formatDate.date(
            this.covertDate(this.Delivery.Time.From)
          );
          const dateMax = formatDate.date(
            this.covertDate(this.Delivery.Time.To)
          );
          return {
            dateMin,
            dateMax,
          };
        } else {
          const dateMax = formatDate.date(
            this.covertDate(this.Delivery.Time.To)
          );
          return {
            dateMax,
          };
        }
      }

      return false;
    },

    tel() {
      if (this.$i18n.locale === 'fr') {
        return '01.85.14.62.85';
      }

      return '+33.1.85.14.62.85';
    },
    productsVisited() {
      return this.$store.state.products_visited.products;
    },
    seo() {
      try {
        if (Array.isArray(this.product.SEO)) {
          let seo = this.product.SEO[0];
          if (this.$i18n.locale === 'en') {
            seo = this.product.SEO[1];
          }
          if (this.$i18n.locale === 'de') {
            seo = this.product.SEO[2];
          }
          return seo;
        } else {
          const seo = this.product.SEO;
          return seo;
        }
      } catch (error) {}

      return null;
    },
    getLinkShopTheLook() {
      try {
        return this.localePath('/shop-the-look/' + this.seo.URL);
      } catch (error) {}
      return '#';
    },
    isGiftCard() {
      return this.product?.Type === 'e-giftcard';
    },
  },
  methods: {
    async permalinkLangUrl() {
      const links = {};

      if (this.product?.SEO) {
        if (Array.isArray(this.product?.SEO)) {
          this.product?.SEO?.map((item, index) => {
            const mainCategory = this.product?.Category?.Main?.SEO?.find(
              (catSeo) => {
                return (
                  item.LanguageIsoCode.toLocaleLowerCase() ===
                  catSeo.LanguageIsoCode.toLocaleLowerCase()
                );
              }
            );

            links[item.LanguageIsoCode.toLowerCase()] = {
              cat: mainCategory?.URL,
              product: item.URL,
            };
          });
        } else {
          const item = this.product?.SEO;
          const mainCategory = this.product?.Category?.Main?.SEO?.find(
            (catSeo) => {
              return (
                item.LanguageIsoCode.toLocaleLowerCase() ===
                catSeo.LanguageIsoCode.toLocaleLowerCase()
              );
            }
          );

          links[item.LanguageIsoCode.toLowerCase()] = {
            cat: mainCategory?.URL,
            product: item.URL,
          };
        }

        await this.$store.dispatch('i18n/setRouteParams', links);
      }
    },
    selectSize(event) {
      const attr = event.variant;
      this.colorSelected = event.color;
      this.sizeSelected = event.size;
      this.isSelectedSize = true;

      this.isAvailbale = attr.Quantity > 0;
      this.idProductAttributeSelected =
        event.variant.Combination.IdProductAttribute;
    },

    sizeClick(event) {
      this.selectSize(event);
      if (process.client) {
        if (this.$SETTINGS.isTablette) {
          if (this.isSelectedSize) {
            if (this.isAvailbale) {
              this.setProductToCart();
              this.taillesIsOpen = false;
            } else {
              this.$refs['ProductNotAvailable'].open();
              setTimeout(() => {
                this.isAvailbale = true;
              }, 300);
            }
            this.taillesIsOpen = false;
          }
        }
      }
    },

    toggleAddToCart() {
      const refs = this.$refs;
      let taillesWrapper = refs.tailles;
      let btnAddWrapper = refs.btnAdd;

      if (this.taillesIsOpen) {
        this.taillesIsOpen = false;
      } else {
        this.taillesIsOpen = true;
      }
    },
    addToCart(options) {
      this.isSelectedSize = this.sizeSelected !== null;

      if (this.isSelectedSize) {
        this.setProductToCart(options);
      }
    },

    openSizes() {
      if (process.client) {
        this.toggleAddToCart();
      }
    },

    setProductToCart(options) {
      console.log('options', options);
      let params = {
        idCart: this.cart.IdCart,
        product: this.product,
        idProductAttribute: this.idProductAttributeSelected,
      };
      if (this.isGiftCard) {
        if (options) {
          params = {
            ...params,
            ...{
              mobilePhone: options.mobilePhone || '',
              firstName: options.firstName || '',
              lastName: options.lastName || '',
              email: options.email || '',
              message: options.message || '',
              dateSend: options.dateSend || '',
            },
          };
        }
        params.languageIsoCode = this.$i18n.locale;
        params.productType = this.isGiftCard ? 'e-giftcard' : '';
      }

      this.cartService.addToCart(params).then((data) => {
        this.cartService.fetchCart({
          onSuccess: (data) => {
            this.openRightBarCart();
          },
        });

        // this.$gtag.event('add_to_cart', {
        //   items: [
        //     {
        //       item_id: this.product.IdProduct,
        //       quantity: 1,
        //     },
        //   ],
        // });

        this.$gtm.push({
          event: 'add_to_cart',
          ecommerce: {
            currency: this.$localisation.appCurrency.CurrencyIsoCode,
            items: [
              {
                item_id: this.product.IdProduct,
                quantity: 1,
              },
            ],
          },
        });
      });
    },

    openBookingDialog() {
      this.$refs['bookingDialog'].openDialog();
    },

    handleScroll(event) {
      // Any code to be executed when the window is scrolled
      if (this.taillesIsOpen) {
        this.taillesIsOpen = false;
        this.isAvailbale = true;
      }
      this.updateAddToCartVisibility();
    },

    isElementPartiallyVisible(el) {
      if (!el) {
        return false;
      }
      const rect = el.getBoundingClientRect();
      const viewportHeight =
        window.innerHeight || document.documentElement.clientHeight;
      const viewportWidth =
        window.innerWidth || document.documentElement.clientWidth;

      const verticallyVisible = rect.bottom > 0 && rect.top < viewportHeight;
      const horizontallyVisible = rect.right > 0 && rect.left < viewportWidth;

      return verticallyVisible && horizontallyVisible;
    },

    updateAddToCartVisibility() {
      if (!process.client) {
        return;
      }

      const isMobile = window.matchMedia('(max-width: 1023px)').matches;
      if (!isMobile) {
        this.hideAddToCartMobile = false;
        return;
      }

      let mainSection = this.$refs.addToCartMain;
      if (Array.isArray(mainSection)) {
        mainSection = mainSection[0];
      }

      const mainVisible = this.isElementPartiallyVisible(mainSection);
      this.hideAddToCartMobile = mainVisible;
    },

    AddToCartGiftCard(payload) {
      // this.addToCart(payload);
      if (payload) {
        this.addToCart(payload);
      } else {
        this.addToCart();
      }
    },

    loadProductSimilar() {
      // const productHelpers = new ProductHelpers(this.$http, this);
      // const permalink = this.$route.params.product;
      // productHelpers
      //   .getProductstSimilar(permalink)
      //   .then((response) => {
      //     this.productsSimilar = response.data;
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    trackKlaviyoViewedProduct() {
      if (process.client) {
        window.klaviyo.push([
          'track',
          'Viewed Product',
          { ProductID: this.product.IdProduct },
        ]);
      }
    },
  },
  mounted() {
    if (process.client) {
      window.scrollTo(0, 0);
      window.addEventListener('resize', this.updateAddToCartVisibility);
      this.entranceTime = Date.now();
    }

    this.$store.commit('products_visited/init', {
      $auth: this.$auth,
    });

    if (this.product) {
      this.$store.commit('products_visited/addProduct', {
        product: this.product,
        $auth: this.$auth,
      });
    }

    this.$store.commit('shared/menu/setAlwaysMenuSticky', true);
    this.$store.commit('shared/topBanner/setAlwaysDisable', true);
    const permalink = this.$route.params.product;
    const token = this.$route.query.token;

    this.$store
      .dispatch('product/fetchProduct', {
        permalink,
        currencyIsoCode: this.$localisation.appCurrency.CurrencyIsoCode,
        token,
      })
      .then((data) => {
        this.permalinkLangUrl();

        // this.$gtag.event('view_item', {
        //   items: [
        //     {
        //       item_id: this.product.IdProduct,
        //       quantity: 1,
        //     },
        //   ],
        // });

        this.$gtm.push({
          event: 'view_item',
          ecommerce: {
            currency: this.$localisation.appCurrency.CurrencyIsoCode,
            value: this.productPrice,
            items: [
              {
                item_id: this.product.IdProduct,
                quantity: 1,
                price: this.productPrice,
                item_name: this.productTitle,
                item_brand: this.product?.Brand?.Name || 'JMP',
                item_category: `#${this.product?.Category?.Main?.IdCategory} : ${this.mainCatgoryTitle}`,
                // item_variant: this.sizeSelected,
              },
            ],
          },
        });
        this.trackKlaviyoViewedProduct();
      })
      .catch((err) => {
        this.notFound = true;
      })
      .finally(() => {
        this.loading = false;
        this.$nextTick(() => {
          setTimeout(() => {
            this.updateAddToCartVisibility();
          }, 1000);
        });
      });
  },

  created() {
    if (process.client) {
      window.addEventListener('scroll', this.handleScroll);
    }

    this.loadProductSimilar();
  },

  beforeDestroy() {
    if (this.product?.IdProduct && this.entranceTime) {
      const timeSpent = Math.floor((Date.now() - this.entranceTime) / 1000);
      if (timeSpent > 0) {
        const productHelpers = new ProductHelpers(
          this.$http,
          this,
          this.$i18n.locale
        );
        const ipAddress = this.$store.state.shop.localisation.visitor?.ip;
        productHelpers.trackProductSession({
          idProduct: this.product.IdProduct,
          duration: timeSpent,
          ipAddress,
        });
      }
    }

    if (process.client) {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.updateAddToCartVisibility);
    }
  },

  destroyed() {
    this.$store.commit('shared/menu/setAlwaysMenuSticky', false);
    this.$store.commit('shared/topBanner/setAlwaysDisable', false);
  },

  components: {
    CarouselImages,
    ProductInformations,
    ProductRelationship,
    ProductSizes,
    Button,
    ProductNotAvailable,
    Collapse,
    CollapseItem,
    MapPinIcon,
    ProductLoading,
    PageNotFound,
    Alert,
    Edit2Icon,
  },
};
